import React from "react";

class ResBotAlumno extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        menualumno:{},
      };

      this.triggetNext = this.triggetNext.bind(this);
  }

    triggetNext(trigger) {
      this.setState({ trigger: true }, () => {
        this.props.triggerNextStep({trigger: trigger});
      });
    }

    componentDidMount() {
      const { steps } = this.props;
      const { menualumno } = steps;
      let id = menualumno.value;
      let url ='http://127.0.0.1:8000/api/menu_alumno/menu/'+id;
      fetch(url)
        .then(response => response.json())
        .then(data => {
          // Descomentar la siguiente línea para revisar la respuesta del API
          console.log(data);
          if(data.opcion === 'Departamento de Admisión'){
            this.triggetNext('consulta-correo');
          }else{
            this.triggetNext('fin-consulta');
          }
          //Actualiza el estado de la prop del componente respuesta con la respuesta del api 
          this.setState({ menualumno:data });
         
        })
        .catch(error => {
          // Aquí se maneja el error si es que falla la consulta al API
          this.setState({ menualumno:{'respuesta':'No se pudo establecer conexion con el servidor'} });
          //Imprime el error en consola en la siguiente linea 
          console.error(error);
        });
    }

    render() {
      const { menualumno } = this.state;
      return (
        <div dangerouslySetInnerHTML={{__html: menualumno.respuesta}}></div>
      );
    }
  }
  
  export default ResBotAlumno;


 